/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Whathappensnext3Inputs */

const id_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terjadi selanjutnya?`)
};

const ms_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berlaku seterusnya?`)
};

const da_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad sker der så?`)
};

const de_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was passiert als nächstes?`)
};

const en_us2_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens next?`)
};

const es_es2_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa después?`)
};

const es_mx2_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué sigue?`)
};

const fil_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang susunod na mangyayari?`)
};

const fr_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la suite ?`)
};

const it_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede dopo?`)
};

const hu_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi történik ezután?`)
};

const nl_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurt er hierna?`)
};

const no_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva skjer videre?`)
};

const pl_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co dalej?`)
};

const pt_br2_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece a seguir?`)
};

const pt_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece a seguir?`)
};

const ro_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce urmează?`)
};

const fi_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä tapahtuu seuraavaksi?`)
};

const sv_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad händer härnäst?`)
};

const vi_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều gì tiếp theo?`)
};

const tr_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırada ne var?`)
};

const cs_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co bude dál?`)
};

const bg_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какво следва?`)
};

const ru_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что дальше?`)
};

const uk_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що далі?`)
};

const ar_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماذا بعد؟`)
};

const hi_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगे क्या?`)
};

const th_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดอะไรขึ้นต่อไป?`)
};

const ja_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のステップ：`)
};

const zh_cn2_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下来会发生什么？`)
};

const zh_hant1_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下來會發生什麼？`)
};

const ko_misc_androidbeta_whathappensnext3 = /** @type {(inputs: Misc_Androidbeta_Whathappensnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 단계는 무엇인가요?`)
};

/**
* | output |
* | --- |
* | "What happens next?" |
*
* @param {Misc_Androidbeta_Whathappensnext3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_whathappensnext3 = /** @type {((inputs?: Misc_Androidbeta_Whathappensnext3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Whathappensnext3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "ms") return ms_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "da") return da_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "de") return de_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "fil") return fil_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "fr") return fr_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "it") return it_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "hu") return hu_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "nl") return nl_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "no") return no_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "pl") return pl_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "pt") return pt_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "ro") return ro_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "fi") return fi_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "sv") return sv_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "vi") return vi_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "tr") return tr_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "cs") return cs_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "bg") return bg_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "ru") return ru_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "uk") return uk_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "ar") return ar_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "hi") return hi_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "th") return th_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "ja") return ja_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_whathappensnext3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_whathappensnext3(inputs)
	return ko_misc_androidbeta_whathappensnext3(inputs)
});
export { misc_androidbeta_whathappensnext3 as "misc.androidBeta.whatHappensNext" }